import { memo } from 'react';
import { SidebarColumns } from '../table/components/SidebarColumns';

type SummaryMatchColumnsPanelProps = {
  view: string;
  tab: string;
  source: string;
  columnVisibilityModel: Record<string, boolean>;
  setColumnVisibilityModel: (updater: (prev: Record<string, boolean>) => Record<string, boolean>) => void;
  columnOrder: string[];
  setColumnOrder: (order: string[]) => void;
};

function SummaryMatchColumnsPanel({
  view,
  tab,
  source,
  columnVisibilityModel,
  setColumnVisibilityModel,
  columnOrder,
  setColumnOrder,
}: SummaryMatchColumnsPanelProps) {
  return (
    <aside className="summary-match-modal-columns-pane">
      <div className="shrink-0 border-b border-slate-200 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-slate-600">
        Table columns
      </div>
      <div className="summary-match-modal-columns-scroll">
        <SidebarColumns
          view={view}
          tab={tab}
          source={source}
          isEvidence={false}
          columnVisibilityModel={columnVisibilityModel}
          setColumnVisibilityModel={setColumnVisibilityModel}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
        />
      </div>
    </aside>
  );
}

export default memo(SummaryMatchColumnsPanel);
